import * as React from "react";
import { NumberInput, TextInput, useRecordContext } from "react-admin";
import Transformer from "src/common/Transformer";
import { SampleEditComponent } from "./SampleComponent";
import { Edit, TabbedForm, FormTab } from "src/enterprise/ra-rbac";
import { Grid, Divider } from "@mui/material";
import { InputHelper } from 'src/components/input';
import { ReservedTable } from './tables';

export const SampleEdit = () => {
  const transform = (data) => {
    Transformer(data, {
      remove: [
        "id",
        "createdAt",
        "createdBy",
        "updatedAt",
        "updatedBy",
        "reserved",
        "reservedQuantityTotal"
      ],
      update: {
        reservedQuantity: data.reserved_quantity,
        product: data.product.id,
      },
    });

    return data;
  };

  return (
    <Edit
      component={SampleEditComponent}
      mutationMode="pessimistic"
      transform={transform}
    >
      <SampleEditForm />
    </Edit>
  );
};

const SampleEditForm = (props) => {
  const record = useRecordContext();

  return (
    <TabbedForm>
      <FormTab label="General" name="general">
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item sm={12} lg={6}>
            <TextInput disabled source="id" />
          </Grid>
          <Grid item sm={12} lg={6}>
            <TextInput
              disabled
              source="product.id"
              label="Product"
              sx={{ minWidth: "35vw" }}
            />
          </Grid>
          <Grid item sm={12} lg={6}>
            <NumberInput source="quantity" required />
          </Grid>
        </Grid>
      </FormTab>
      <FormTab label={`Reserved (${record.reserved_quantity_total})`} name="reserved">
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item sm={12} lg={12}>
            <NumberInput source="reserved_quantity" helperText={<InputHelper text="Use to manually add reserved qunatity." />} />
          </Grid>
          <Grid item sm={12} lg={12}>
            <Divider
              sx={{
                borderColor: "#dfdfdf",
                my: "30px",
              }}
            />
            <ReservedTable record={record}/>
          </Grid>
        </Grid>
      </FormTab>
    </TabbedForm>
  )
};
